// frontend/src/components/Session/RestorePrompt.tsx
import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { listStashKeys, readStash, clearStash } from '../../contexts/SessionGuardContext';
import { useAuth } from '../../contexts/AuthContext';

export function RestorePrompt() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [keys, setKeys] = useState<string[]>([]);

  useEffect(() => { if (isAuthenticated) setKeys(listStashKeys()); }, [isAuthenticated]);
  if (!isAuthenticated || keys.length === 0) return null;

  const first = keys[0];
  const stash = readStash(first);
  const route: string | undefined = stash?.route;

  const dismissAll = () => { keys.forEach(clearStash); setKeys([]); };
  const restore = () => {
    setKeys([]);
    // Arm the registry hooks: the target editor will re-apply its stash on mount.
    sessionStorage.setItem('cnf_restore_armed', '1');
    if (route) navigate(route);
  };

  return (
    <Modal
      open
      centered
      title="Restore your unsaved work?"
      okText="Restore"
      cancelText="Discard"
      onOk={restore}
      onCancel={dismissAll}
    >
      You have unsaved work from your last session. Restore it?
    </Modal>
  );
}
